(() => {
  const root = document.querySelector('[data-focus-product]');
  if (!root) return;
  const frames = [...root.querySelectorAll('[data-focus-frame]')];
  const thumbs = [...root.querySelectorAll('[data-focus-thumb]')];
  const showFrame = (button) => {
    frames.forEach(frame => { frame.hidden = frame.dataset.focusFrame !== button.dataset.focusThumb; });
    thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
  };
  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => showFrame(thumb));
    thumb.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
      showFrame(thumbs[next]); thumbs[next].focus();
    });
  });
  root.querySelector('[data-focus-variant]')?.addEventListener('change', event => {
    // Fetch a fresh server-rendered variant page so price, availability and
    // selling-plan allocations always come from the same Shopify variant.
    const submit = root.querySelector('button[type="submit"]');
    if (submit) submit.disabled = true;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', event.target.value);
    window.location.assign(url.toString());
  });
})();
